<template>
<div class="container-fluid">
    <div class="row center-xs">
        <div class="col-sm-8 col-xs-12">
          <div class="form-container"> 
            <form id="settingsForm" name="settingsForm">
              
                <div class="form__wrapper">
                    <input class="form__input" type="text" name="bannerUrl" v-model="currentSettings.bannerUrl" required> 
                    <label class="form__label" for="bannerUrl">Banner URL</label>
                </div>

                <div class="form-error" v-if="errorMsg">
                  <alert-circle-icon></alert-circle-icon> {{errorMsg}} 
                </div>

                <div class="form__wrapper--submit">
                  <div class="form-input--submit">
                    <button type="button" :disabled="!isFormValid" class="btn btn-block" @click="updateSettings(currentSettings)">
                        <span>
                            UPDATE
                         </span>
                    </button>
                  </div>
                </div>  

            </form>
          </div>
        </div>
    </div>
</div>
</template>

<script>
import { SettingsService } from "@/services/ApiService.js";
import AlertCircleIcon from 'vue-material-design-icons/AlertCircle.vue';

export default {
    name: 'SettingsForm',
    components: {
      AlertCircleIcon,
    },
    props: {
      settings: Object
    },
    data() {
        return {
          currentSettings: {},
          errorMsg: ''         
        }
    },
    created: function () {
        this.currentSettings = this.settings;
    },
    methods: {
      updateSettings(settings) {
          SettingsService.update(this.settings._id, settings).then((res) => {
              this.currentSettings = res.data;
          }).catch(err => {
            this.errorMsg = err;
          });
        }
    }, 
    computed: {
      isFormValid: function () {
        return this.settings.bannerUrl.length > 0
      }
    }
}
</script>

<style lang="less" scoped>
.markdown-supported {
  display: block;
  color: var(--text-primary);
  text-align: left;
  opacity: 0.83;
}
.img-url-input {
  width: 90%;
  display: inline-block;
}
.remove-field-link {
  display: inline-block;
  color: crimson;
  margin-left: 10px;
  cursor: pointer;
  text-decoration: none;
}
.form-error {
  margin-top: 20px;
  color: var(--text-primary);
}
.add-img-container {
  text-align: right;
  margin-top: 20px;
}
</style>